import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-payment-terms-and-conditions',
  templateUrl: './payment-terms-and-conditions.component.html',
  styleUrls: ['./payment-terms-and-conditions.component.css'],
})
export class PaymentTermsAndConditionsComponent {
  pdfUrl: any;

  constructor(private modal: CustomModalService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://piqet.ifour-consultancy.net/Template/PIQET_Updated_Terms.pdf'
    );
  }

  onClose() {
    this.modal.close();
  }
}
